import * as React from 'react';

export const WorldNetwork = props => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.2467 3.75C7.85953 3.75 4.30566 7.31164 4.30566 11.691C4.30566 15.8642 7.51191 19.2853 11.6017 19.616C12.0146 19.6494 12.3222 20.0111 12.2888 20.424C12.2554 20.8369 11.8937 21.1445 11.4808 21.1111C6.61685 20.7179 2.80566 16.6506 2.80566 11.691C2.80566 6.4842 7.03012 2.25 12.2467 2.25C17.0709 2.25 21.0394 5.86582 21.6092 10.5327C21.6594 10.9439 21.3668 11.3179 20.9556 11.3681C20.5445 11.4183 20.1705 11.1257 20.1203 10.7145C19.6411 6.78965 16.3023 3.75 12.2467 3.75Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.7191 4.24501C10.2696 3.19815 11.1044 2.25 12.247 2.25C13.3939 2.25 14.2288 3.19698 14.779 4.24557C15.3591 5.35121 15.7861 6.85966 16.0196 8.56566C16.1228 9.27202 16.1881 10.0122 16.2162 10.7771C16.2314 11.191 15.9082 11.5389 15.4943 11.5541C15.0803 11.5693 14.7324 11.2461 14.7172 10.8321C14.6909 10.1154 14.6299 9.42835 14.5349 8.77936L14.5339 8.77234C14.3148 7.16958 13.9237 5.84395 13.4507 4.94253C12.9474 3.98329 12.4935 3.75 12.247 3.75C12.006 3.75 11.5521 3.98213 11.0468 4.9431C10.5727 5.84471 10.1796 7.17031 9.96111 8.77212L9.96026 8.77834C9.82956 9.68012 9.75977 10.657 9.75977 11.691C9.75977 12.7254 9.82959 13.711 9.96024 14.6125L9.961 14.6178C10.2627 16.8093 11.1943 18.869 12.0959 19.8584C12.3749 20.1645 12.3529 20.6389 12.0468 20.9179C11.7406 21.1969 11.2662 21.1749 10.9872 20.8687C9.82844 19.5973 8.80654 17.2271 8.47536 14.825C8.33382 13.8473 8.25977 12.7905 8.25977 11.691C8.25977 10.5914 8.33384 9.5435 8.4753 8.5663C8.7084 6.85917 9.1378 5.35054 9.7191 4.24501Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.80566 11.6992C2.80566 11.285 3.14145 10.9492 3.55566 10.9492H11.8536C12.2678 10.9492 12.6036 11.285 12.6036 11.6992C12.6036 12.1134 12.2678 12.4492 11.8536 12.4492H3.55566C3.14145 12.4492 2.80566 12.1134 2.80566 11.6992Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5864 13.7188C16.146 13.7188 14.9785 14.8862 14.9785 16.3265C14.9785 17.2472 15.5385 18.2411 16.2668 19.0609C16.6197 19.4583 16.9845 19.7828 17.281 20.002C17.4035 20.0925 17.5068 20.1595 17.5864 20.2049C17.6661 20.1595 17.7693 20.0925 17.8918 20.002C18.1884 19.7828 18.5531 19.4583 18.9061 19.0609C19.6343 18.2411 20.1943 17.2472 20.1943 16.3265C20.1943 14.8862 19.0268 13.7188 17.5864 13.7188ZM13.4785 16.3265C13.4785 14.0578 15.3176 12.2188 17.5864 12.2188C19.8552 12.2188 21.6943 14.0578 21.6943 16.3265C21.6943 17.7956 20.8439 19.1381 20.0275 20.0571C19.6081 20.5292 19.1669 20.9247 18.7835 21.2082C18.5926 21.3493 18.4048 21.4709 18.2319 21.5611C18.0954 21.6324 17.851 21.7491 17.5864 21.7491C17.3218 21.7491 17.0774 21.6324 16.9409 21.5611C16.768 21.4709 16.5802 21.3493 16.3893 21.2082C16.0059 20.9247 15.5647 20.5292 15.1453 20.0571C14.3289 19.1381 13.4785 17.7956 13.4785 16.3265Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5615 16.2422C16.5615 15.6899 17.0092 15.2422 17.5615 15.2422H17.6073C18.1595 15.2422 18.6073 15.6899 18.6073 16.2422C18.6073 16.7945 18.1595 17.2422 17.6073 17.2422H17.5615C17.0092 17.2422 16.5615 16.7945 16.5615 16.2422Z"
      fill="#64748B"
    />
  </svg>
);
